import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthShell from '../comps/authShell'
import { BigInput, InputErrorMassage } from '../comps/comps'
import { getSignupDraft, setSignupDraft } from '../utils/signupDraft'

const AuthBio = () => {
  const navigate = useNavigate()
  const [bio, setBio] = useState('')
  const [tried, setTried] = useState(false)

  useEffect(() => {
    const draft = getSignupDraft()
    if (!draft.email || !draft.password || !draft.name) navigate('/auth', { replace: true })
    if (draft.bio) setBio(draft.bio)
  }, [navigate])

  const next = () => {
    setTried(true)
    const text = String(bio || '').trim()
    if (text.length < 3 || text.length > 200) return
    setSignupDraft({ bio: text })
    navigate('/auth/setup/photo')
  }

  return (
    <AuthShell title="Your bio">
      <p className="authStepLabel">Write a short bio</p>
      <BigInput height="110px" placeholder="Tell people about you" value={bio} onChange={e => setBio(e.target.value)} />
      {tried && <InputErrorMassage val={String(bio || '').trim()} num={[3, 200]} text="bio should be 3 to 200 letters" />}
      <button type="button" className="googlebuttons" onClick={next}>Next</button>
      <p className="googlebuttonss" onClick={() => navigate('/auth/setup/name')}>Back</p>
    </AuthShell>
  )
}

export default AuthBio
